// extracted by mini-css-extract-plugin
export default {"wrapper":"HD-z","button":"ID-z","alternate":"JD-z","disabled":"KD-z","paymentWarning":"LD-z","fadeIn":"MD-z"};